import { HomePage } from "../pages/Home/index";
import { Route } from "../shared/Interface/route";

export const publicRoutes: Route[] = [
  {
    key: "router-home",
    title: "Home",
    description: "BM Helpdesk Home",
    component: HomePage,
    path: "/",
    isEnabled: true,
    appendDivider: false,
  },
];
